import axios, { AxiosInstance, AxiosError } from "axios";
import { ApiError } from "@app-types/tap-partner-vault";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 120000,
  withCredentials: true,
});

export const shouldLogoutForApiError = (
  error: AxiosError<ApiError>
): boolean => {
  return (
    error.response?.status === 401 &&
    error.response?.data?.error === "Unauthorized"
  );
};

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiError>) => {
    if (
      shouldLogoutForApiError(error) &&
      window.location.pathname !== "/login"
    ) {
      window.location.href = "/api/auth/logout";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
